export default __webpack_public_path__ + "static/media/ishopify-sidebar-layers.d50dfb64.png";